import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { editOrdersProducts, reviseOrder, deleteOrderProduct, getOrderById } from '@/api/order';
import { getProductById, searchProducts } from '@/api/products';
import { getQuery } from '@/utils';
import { Component, Prop, Vue } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.tableData = [];
    this.originalData = [];
    this.saveLoading = false;
    this.creditLimitAvailable = 0;
    // Snapshot of this order's total value at load time (BEFORE any edits).
    // The backend's creditLimitAvailable already has this amount deducted,
    // so it must be added back to know what's truly available for editing
    // this specific order.
    this.originalOrderTotal = 0;
  }
  async created() {
    // Deep copy of data to avoid mutating prop directly
    this.tableData = JSON.parse(JSON.stringify(this.data));
    this.originalData = JSON.parse(JSON.stringify(this.data));
    // Snapshot the order's original total (pieces * nettRate) as it stood
    // before any edits — this is the amount already deducted from
    // creditLimitAvailable by the backend.
    this.originalOrderTotal = this.originalData.reduce((sum, row) => {
      var _row$quantity;
      const pieces = Number((_row$quantity = row.quantity) !== null && _row$quantity !== void 0 ? _row$quantity : row.numberOfPieces) || 0;
      const rate = Number(row.nettRate) || 0;
      return sum + pieces * rate;
    }, 0);
    // Fetch the order details
    try {
      var _response$data, _response$order;
      const response = await getOrderById(this.data[0].orderId);
      // Debug: inspect the raw response shape once, remove this log once confirmed
      console.log('getOrderById raw response:', response);
      // Handle common response wrapper shapes:
      // 1) response.dealer.creditLimitAvailable
      // 2) response.data.dealer.creditLimitAvailable
      // 3) response.order.dealer.creditLimitAvailable
      const dealer = (response === null || response === void 0 ? void 0 : response.dealer) || (response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.dealer) || (response === null || response === void 0 || (_response$order = response.order) === null || _response$order === void 0 ? void 0 : _response$order.dealer) || null;
      if (!dealer) {
        console.warn('Could not locate dealer object in response:', response);
      }
      const rawCredit = dealer === null || dealer === void 0 ? void 0 : dealer.creditLimitAvailable;
      // Handle numeric strings with commas, e.g. "4,214,341.80"
      const parsedCredit = typeof rawCredit === 'string' ? parseFloat(rawCredit.replace(/,/g, '')) : Number(rawCredit);
      this.creditLimitAvailable = isNaN(parsedCredit) ? 0 : parsedCredit;
      console.log('Resolved creditLimitAvailable:', this.creditLimitAvailable);
      console.log('Original order total (already deducted by backend):', this.originalOrderTotal);
      console.log('Effective available for this order:', this.effectiveAvailable);
    } catch (error) {
      console.error('Failed to fetch order/dealer credit info:', error);
      this.$message.error('Could not load credit limit information.');
    }
    // Initialize product search state and quantity fields for each row
    this.tableData.forEach((row, index) => {
      var _row$numberOfCartons, _row$numberOfBoxes;
      this.$set(row, 'selectedProduct', null);
      this.$set(row, 'products', []);
      this.$set(row, 'productListLoading', false);
      // Initialize quantity fields, preserving data prop values
      this.$set(row, 'numberOfCartons', (_row$numberOfCartons = row.numberOfCartons) !== null && _row$numberOfCartons !== void 0 ? _row$numberOfCartons : 0);
      this.$set(row, 'numberOfBoxes', (_row$numberOfBoxes = row.numberOfBoxes) !== null && _row$numberOfBoxes !== void 0 ? _row$numberOfBoxes : 0);
      this.$set(row, 'numberOfPieces', row.quantity || row.product.piecesPerBox || 0);
      // Apply quantity checks to ensure consistency
      this.checkQuantity(index, row);
    });
  }
  // ---- Real-time credit limit computations ----
  get currentOrderTotal() {
    return this.tableData.reduce((sum, row) => {
      const pieces = Number(row.numberOfPieces) || 0;
      const rate = Number(row.nettRate) || 0;
      return sum + pieces * rate;
    }, 0);
  }
  // The dealer's true available credit AS IF this order's original value
  // had never been deducted. creditLimitAvailable from the backend already
  // excludes this order's original total, so we add it back to get the
  // real ceiling for editing this order.
  get effectiveAvailable() {
    return this.creditLimitAvailable + this.originalOrderTotal;
  }
  // What's actually left right now, accounting for the current (possibly
  // edited) state of this order. This is the figure shown as "Credit
  // Available" and used to decide the success/danger tag color.
  get creditAvailableNow() {
    return this.effectiveAvailable - this.currentOrderTotal;
  }
  handleEdit(row) {
    this.$set(row, 'isEditing', true);
    this.$set(row, 'selectedProduct', row.product.name); // Initialize with product name
    this.fetchVariations(row);
  }
  async fetchVariations(row) {
    try {
      const productId = row.product.id;
      const response = await getProductById(productId, {
        enabled: true,
        'productsVariation.enabled': true
      });
      const variationData = response.productsVariation || [];
      this.$set(row.product, 'variations', variationData);
      this.$set(row.product, 'masterCarton', response.masterCarton || 0);
      this.$set(row.product, 'piecesPerBox', response.piecesPerBox || 0);
      const currentVariation = row.productsVariation.id;
      const selectedVariation = variationData.find(v => v.id === currentVariation);
      if (!selectedVariation) {
        var _variationData$, _variationData$2, _variationData$3;
        row.productsVariation.id = ((_variationData$ = variationData[0]) === null || _variationData$ === void 0 ? void 0 : _variationData$.id) || null;
        row.productsVariation.name = ((_variationData$2 = variationData[0]) === null || _variationData$2 === void 0 ? void 0 : _variationData$2.name) || '';
        row.mrp = ((_variationData$3 = variationData[0]) === null || _variationData$3 === void 0 ? void 0 : _variationData$3.mrp) || 0;
      } else {
        row.mrp = selectedVariation.mrp || row.mrp;
      }
      this.calculateNumberOfPieces(row);
    } catch (error) {
      console.error('Error fetching variations:', error);
      this.$message.error('Failed to load variations. Please try again.');
      this.$set(row.product, 'variations', []);
      this.$set(row.product, 'masterCarton', 0);
      this.$set(row.product, 'piecesPerBox', 0);
    }
  }
  async getProductList(query, row) {
    try {
      this.$set(row, 'productListLoading', true);
      if (query && query.length > 2) {
        const products = await searchProducts(getQuery({
          keyword: query
        }));
        this.$set(row, 'products', products || []);
      } else {
        this.$set(row, 'products', []);
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      this.$message.error('Failed to load products. Please try again.');
      this.$set(row, 'products', []);
    } finally {
      this.$set(row, 'productListLoading', false);
    }
  }
  handleProductSelection(row) {
    if (!row.selectedProduct) {
      this.$set(row.product, 'id', '');
      this.$set(row.product, 'name', '');
      this.$set(row.product, 'masterCarton', 0);
      this.$set(row.product, 'piecesPerBox', 0);
      this.$set(row.productsVariation, 'id', '');
      this.$set(row.productsVariation, 'name', '');
      this.$set(row.product, 'variations', []);
      this.$set(row, 'mrp', 0);
      this.$set(row, 'numberOfCartons', 0);
      this.$set(row, 'numberOfBoxes', 0);
      this.$set(row, 'numberOfPieces', 0);
      return;
    }
    const selectedProduct = row.products.find(p => p.name === row.selectedProduct);
    if (selectedProduct) {
      this.$set(row.product, 'id', selectedProduct.id);
      this.$set(row.product, 'name', selectedProduct.name);
      this.$set(row.product, 'masterCarton', selectedProduct.masterCarton || 0);
      this.$set(row.product, 'piecesPerBox', selectedProduct.piecesPerBox || 0);
      this.$set(row.productsVariation, 'id', '');
      this.$set(row.productsVariation, 'name', '');
      this.$set(row.product, 'variations', []);
      this.$set(row, 'mrp', 0);
      this.$set(row, 'numberOfCartons', 0);
      this.$set(row, 'numberOfBoxes', 1);
      this.$set(row, 'numberOfPieces', selectedProduct.piecesPerBox || 0);
      this.fetchVariations(row);
    }
  }
  updateVariationName(row) {
    const selectedVariation = row.product.variations.find(variation => variation.id === row.productsVariation.id);
    if (selectedVariation) {
      row.productsVariation.name = selectedVariation.name;
      this.$set(row, 'mrp', selectedVariation.mrp || 0);
      this.calculateNumberOfPieces(row);
    }
  }
  checkQuantity(index, row) {
    if (row.numberOfCartons === 0 && row.numberOfBoxes === 0) {
      setTimeout(() => {
        this.$set(this.tableData[index], 'numberOfBoxes', 1);
        this.calculateNumberOfPieces(row);
      }, 500);
    } else if (typeof row.numberOfCartons === 'undefined') {
      setTimeout(() => {
        this.$set(this.tableData[index], 'numberOfCartons', 0);
        this.calculateNumberOfPieces(row);
      }, 500);
    } else if (typeof row.numberOfBoxes === 'undefined') {
      setTimeout(() => {
        this.$set(this.tableData[index], 'numberOfBoxes', 0);
        this.calculateNumberOfPieces(row);
      }, 500);
    } else {
      this.calculateNumberOfPieces(row);
    }
  }
  calculateNumberOfPieces(row) {
    let numberOfPieces = 0;
    if (row.numberOfCartons > 0) {
      numberOfPieces += row.numberOfCartons * (row.product.masterCarton || 0);
    }
    if (row.numberOfBoxes > 0) {
      numberOfPieces += row.numberOfBoxes * (row.product.piecesPerBox || 0);
    }
    this.$set(row, 'numberOfPieces', numberOfPieces);
    this.$set(row, 'quantity', numberOfPieces);
  }
  validateCreditLimit() {
    if (this.currentOrderTotal > this.effectiveAvailable) {
      this.$message.error(`Order total (${this.currentOrderTotal.toFixed(2)}) exceeds available credit limit (${this.effectiveAvailable.toFixed(2)}). Please adjust quantities before saving.`);
      return false;
    }
    return true;
  }
  async handleSave(row) {
    if (!row.product.name || !row.productsVariation.id || row.numberOfPieces <= 0) {
      this.$message.error('Please select a valid product, variation, and ensure quantity is greater than 0');
      return;
    }
    if (!this.validateCreditLimit()) {
      return;
    }
    try {
      const data = {
        productId: row.product.id,
        productsVariationId: row.productsVariation.id,
        quantity: row.numberOfPieces,
        numberOfCartons: row.numberOfCartons,
        numberOfBoxes: row.numberOfBoxes
      };
      await editOrdersProducts(row.id, data);
      const index = this.originalData.findIndex(item => item.id === row.id);
      if (index !== -1) {
        this.originalData[index].product.id = row.product.id;
        this.originalData[index].product.name = row.product.name;
        this.originalData[index].product.masterCarton = row.product.masterCarton;
        this.originalData[index].product.piecesPerBox = row.product.piecesPerBox;
        this.originalData[index].productsVariation.id = row.productsVariation.id;
        this.originalData[index].productsVariation.name = row.productsVariation.name;
        this.originalData[index].quantity = row.numberOfPieces;
        this.originalData[index].numberOfCartons = row.numberOfCartons;
        this.originalData[index].numberOfBoxes = row.numberOfBoxes;
        this.originalData[index].numberOfPieces = row.numberOfPieces;
        this.originalData[index].mrp = row.mrp;
      }
      this.$set(row, 'isEditing', false);
      this.$message.success('Changes saved successfully');
      this.$emit('update:data', this.originalData);
    } catch (error) {
      console.error('Error updating order product:', error);
      this.$message.error('Failed to save changes. Please try again.');
    }
  }
  async handleDelete(row) {
    try {
      await this.$confirm('Are you sure you want to delete this product from the order?', 'Confirm Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      });
      await deleteOrderProduct(row.id);
      this.tableData = this.tableData.filter(item => item.id !== row.id);
      this.originalData = this.originalData.filter(item => item.id !== row.id);
      this.$emit('update:data', this.originalData);
      await reviseOrder({
        id: this.tableData[0].orderId,
        saveDiscounts: true,
        skipReturn: true
      });
      this.$message.success('Product deleted successfully');
    } catch (error) {
      console.error('Error deleting order product:', error);
      this.$message.error('Failed to delete product. Please try again.');
    }
  }
  async handleSaveAll() {
    const isEditing = this.tableData.some(row => row.isEditing);
    if (isEditing) {
      this.$message.error('Please save or cancel all row edits before saving the order.');
      return;
    }
    if (this.tableData.length === 0 || !this.tableData[0].orderId) {
      this.$message.error('No order data available to save.');
      return;
    }
    if (!this.validateCreditLimit()) {
      return;
    }
    try {
      this.saveLoading = true;
      await reviseOrder({
        id: this.tableData[0].orderId,
        saveDiscounts: true,
        skipReturn: true
      });
      this.$message.success('Order saved successfully');
    } catch (error) {
      console.error('Error saving order:', error);
      this.$message.error('Failed to save order. Please try again.');
    } finally {
      this.saveLoading = false;
    }
  }
  handleCancel(row) {
    const originalRow = this.originalData.find(item => item.id === row.id);
    if (originalRow) {
      const index = this.tableData.findIndex(item => item.id === row.id);
      this.$set(this.tableData, index, JSON.parse(JSON.stringify(originalRow)));
      this.$set(this.tableData[index], 'selectedProduct', null);
      this.$set(this.tableData[index], 'products', []);
      this.$set(this.tableData[index], 'productListLoading', false);
    }
    this.$set(row, 'isEditing', false);
  }
};
__decorate([Prop({
  default: []
})], default_1.prototype, "data", void 0);
default_1 = __decorate([Component({
  name: 'OrdersProductsEdit',
  components: {}
})], default_1);
export default default_1;